import yaml from 'js-yaml'
import { AppSettingsType } from '../types/lib/types';

export const fetchAppConfig = async (url: string) => {
  const response = await fetch(`${url}?date=${Date.now()}`)
  const yamlText = await response.text();
  return yaml.load(yamlText) as AppSettingsType;
}
